import * as z from "zod/v4";
import { salesChannelSchema } from "./sales-channel";

export const getSalesChannelOptions = {
  name: "getSalesChannelOptions" as const,
  input: z.object({}),
  output: z
    .object({ salesChannelOptions: z.array(salesChannelSchema) })
    .nullable(),
};

export type SalesChannel = z.infer<typeof salesChannelSchema>;
